var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-layout", { attrs: { row: "", wrap: "", "m-0": "" } }, [
    _c(
      "div",
      { staticClass: "card__header" },
      [
        _c(
          "div",
          { staticClass: "button__container" },
          [
            _c(
              "div",
              {
                staticClass: "addProject button__filter",
                on: {
                  click: function($event) {
                    _vm.showFilter = !_vm.showFilter
                  }
                }
              },
              [
                _c("i", { staticClass: "fas fa-filter " }),
                _vm._v(" "),
                _c("span", [_vm._v("Filter")])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "list__view" }, [
              _c(
                "span",
                {
                  staticClass: "grid__btn",
                  class: { "active-view": _vm.isGridView },
                  on: { click: _vm.hideBtn }
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        id: "grid__btn",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 11.37 11.54"
                      }
                    },
                    [
                      _c(
                        "g",
                        { attrs: { id: "Layer_2", "data-name": "Layer 2" } },
                        [
                          _c(
                            "g",
                            {
                              attrs: { id: "Layer_1-2", "data-name": "Layer 1" }
                            },
                            [
                              _c("path", {
                                staticClass: "cls-1",
                                attrs: {
                                  d:
                                    "M3,3.34H.33A.33.33,0,0,1,0,3V.33A.33.33,0,0,1,.33,0H3a.33.33,0,0,1,.33.33V3A.33.33,0,0,1,3,3.34Z"
                                }
                              }),
                              _c("path", {
                                staticClass: "cls-1",
                                attrs: {
                                  d:
                                    "M7,3.34H4.35A.34.34,0,0,1,4,3V.33A.34.34,0,0,1,4.35,0H7a.34.34,0,0,1,.34.33V3A.34.34,0,0,1,7,3.34Z"
                                }
                              }),
                              _c("path", {
                                staticClass: "cls-1",
                                attrs: {
                                  d:
                                    "M3,7.36H.33A.34.34,0,0,1,0,7V4.35A.34.34,0,0,1,.33,4H3a.34.34,0,0,1,.33.34V7A.34.34,0,0,1,3,7.36Z"
                                }
                              }),
                              _c("path", {
                                staticClass: "cls-1",
                                attrs: {
                                  d:
                                    "M7,7.36H4.35A.34.34,0,0,1,4,7V4.35A.34.34,0,0,1,4.35,4H7a.34.34,0,0,1,.34.34V7A.34.34,0,0,1,7,7.36Z"
                                }
                              }),
                              _c("path", {
                                staticClass: "cls-1",
                                attrs: {
                                  d:
                                    "M11,3.34H8.36A.34.34,0,0,1,8,3V.33A.34.34,0,0,1,8.36,0H11a.34.34,0,0,1,.34.33V3A.34.34,0,0,1,11,3.34Z"
                                }
                              }),
                              _c("path", {
                                staticClass: "cls-1",
                                attrs: {
                                  d:
                                    "M11,7.36H8.36A.34.34,0,0,1,8,7V4.35A.34.34,0,0,1,8.36,4H11a.34.34,0,0,1,.34.34V7A.34.34,0,0,1,11,7.36Z"
                                }
                              }),
                              _c("path", {
                                staticClass: "cls-1",
                                attrs: {
                                  d:
                                    "M3,11.54H.33A.34.34,0,0,1,0,11.2V8.53a.34.34,0,0,1,.33-.34H3a.34.34,0,0,1,.33.34V11.2A.34.34,0,0,1,3,11.54Z"
                                }
                              }),
                              _c("path", {
                                staticClass: "cls-1",
                                attrs: {
                                  d:
                                    "M7,11.54H4.35A.34.34,0,0,1,4,11.2V8.53a.34.34,0,0,1,.34-.34H7a.34.34,0,0,1,.34.34V11.2A.34.34,0,0,1,7,11.54Z"
                                }
                              }),
                              _c("path", {
                                staticClass: "cls-1",
                                attrs: {
                                  d:
                                    "M11,11.54H8.36A.35.35,0,0,1,8,11.2V8.53a.34.34,0,0,1,.34-.34H11a.34.34,0,0,1,.34.34V11.2A.34.34,0,0,1,11,11.54Z"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      attrs: {
                        id: "list__btn",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 13.77 9.83"
                      }
                    },
                    [
                      _c(
                        "g",
                        { attrs: { id: "Layer_2", "data-name": "Layer 2" } },
                        [
                          _c(
                            "g",
                            {
                              attrs: { id: "Layer_1-2", "data-name": "Layer 1" }
                            },
                            [
                              _c("path", {
                                staticClass: "cls-1",
                                attrs: {
                                  d:
                                    "M2,7.87H1a1,1,0,0,0,0,2H2a1,1,0,0,0,0-2ZM2,3.93H1a1,1,0,0,0,0,2H2a1,1,0,0,0,0-2ZM2,0H1A1,1,0,0,0,1,2H2A1,1,0,0,0,2,0ZM5.9,2h6.88a1,1,0,1,0,0-2H5.9a1,1,0,0,0,0,2Zm6.88,2H5.9a1,1,0,0,0,0,2h6.88a1,1,0,1,0,0-2Zm0,3.94H5.9a1,1,0,1,0,0,2h6.88a1,1,0,1,0,0-2Z"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "addProject",
                attrs: { to: { name: "add-story-step-1" } }
              },
              [
                _c("i", { staticClass: "fas fa-plus-circle " }),
                _vm._v(" "),
                _c("span", [_vm._v("Create Project")])
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("v-spacer"),
        _vm._v(" "),
        _vm.$store.state.user.role == "admin" ||
        _vm.$store.state.user.role == "developer"
          ? _c(
              "file-uploader",
              {
                on: { input: _vm.uploadProject },
                model: {
                  value: _vm.uploadedProject,
                  callback: function($$v) {
                    _vm.uploadedProject = $$v
                  },
                  expression: "uploadedProject"
                }
              },
              [
                _c("div", { attrs: { slot: "activator" }, slot: "activator" }, [
                  _c("button", { staticClass: "uploadProject" }, [
                    _c("i", { staticClass: "fas fa-upload " }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Upload Project")])
                  ])
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("SortBy", { on: { sort: _vm.setSortOrderListView } })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "gallery_cards_container" },
      [
        _vm.showFilter && _vm.filtersList.length > 0
          ? _c(
              "div",
              { staticClass: "filter__card" },
              [
                _c("GalleryFilter", { attrs: { filtersList: _vm.filtersList } })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("parentListGridCard", {
          attrs: {
            isGridView: _vm.isGridView,
            search: _vm.search,
            searchByDate: _vm.searchByDate,
            searchDateByCustom: _vm.searchDateByCustom,
            setSortOrder: _vm.setSortOrder,
            list: _vm.userStories,
            organizations: _vm.organizations,
            experienceFilter: _vm.experienceFilter,
            organizationsSideBar: _vm.organizationsSideBar,
            experienceFilterSideBar: _vm.experienceFilterSideBar,
            authorSideBar: _vm.authorSideBar,
            breadCrumbs: _vm.breadCrumbs,
            displayStarredData: _vm.displayStarredData,
            displaySharedData: _vm.displaySharedData
          },
          on: {
            editStory: _vm.editStory,
            copyStory: _vm.copyStory,
            sortOrderFilter: _vm.sortOrderFilter
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-845076a4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-845076a4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/StoryListView.vue
// module id = null
// module chunks = 